import { useEffect, useRef, useState } from 'react';

export function useTrackFPS(enabled: boolean): number[] {
	const [frameTimes, setFrameTimes] = useState<number[]>([]);
	const animationFrame = useRef<number | null>(null);

	useEffect(() => {
		if (!enabled) return;

		setFrameTimes([]);
		let lastFrame: number | null = null;

		const loop = (now: number) => {
			if (lastFrame !== null) {
				const frameTime = now - lastFrame;
				// Only record frame times > 1ms to filter out duplicate/batched calls
				if (frameTime > 1) {
					setFrameTimes((prev) => [...prev, frameTime]);
				}
			}
			lastFrame = now;
			animationFrame.current = requestAnimationFrame(loop);
		};

		animationFrame.current = requestAnimationFrame(loop);

		return () => {
			if (animationFrame.current) cancelAnimationFrame(animationFrame.current);
		};
	}, [enabled]);

	return frameTimes;
}
